<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div class="form-check">
    <input formControlName="entsprichtWohnanschrift" [disabled]="readonly" class="form-check-input"
           id="entsprichtWohnanschrift" type="checkbox">
    <label class="form-check-label" for="entsprichtWohnanschrift">
      {{ entsprichtWohnanschriftLabel | translate }}
    </label>
  </div>
</form>
